const INDIA_BANKS = [
  'State Bank of India',
  'HDFC Bank',
  'ICICI Bank',
  'Axis Bank',
  'Kotak Mahindra Bank',
  'Punjab National Bank',
  'Bank of Baroda',
  'Canara Bank',
  'Union Bank of India',
  'Bank of India',
  'Indian Bank',
  'Central Bank of India',
  'Indian Overseas Bank',
  'UCO Bank',
  'Bank of Maharashtra',
  'Punjab & Sind Bank',
  'IDBI Bank',
  'Federal Bank',
  'Yes Bank',
  'IndusInd Bank',
  'Bandhan Bank',
  'IDFC First Bank',
  'RBL Bank',
  'AU Small Finance Bank',
  'Equitas Small Finance Bank',
  'Ujjivan Small Finance Bank',
  'Jana Small Finance Bank',
  'Suryoday Small Finance Bank',
  'ESAF Small Finance Bank',
  'Fincare Small Finance Bank',
  'Shivalik Small Finance Bank',
  'North East Small Finance Bank',
  'Capital Small Finance Bank',
  'Unity Small Finance Bank',
  'South Indian Bank',
  'Karur Vysya Bank',
  'City Union Bank',
  'Karnataka Bank',
  'Dhanlaxmi Bank',
  'DCB Bank',
  'Jammu & Kashmir Bank',
  'Tamilnad Mercantile Bank',
  'CSB Bank',
  'Nainital Bank',
  'HSBC India',
  'Standard Chartered Bank India',
  'Citibank India',
  'Deutsche Bank India',
  'DBS Bank India',
  'Bank of Bahrain and Kuwait',
  'Barclays Bank India',
  'Bank of Ceylon',
  'Bank of China',
  'Bank of Nova Scotia',
  'BNP Paribas India',
  'Credit Agricole CIB',
  'JP Morgan Chase Bank',
  'MUFG Bank',
  'Mizuho Bank',
  'Sumitomo Mitsui Banking Corporation',
  'NatWest Markets',
  'Societe Generale',
  'UBS Bank',
];

export default INDIA_BANKS;
